import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import MaterialIcons from "../../components/MaterialIcons";
import { adminBg, statsBg, trip, actions } from "../../utils/images";
import navLinks, { getRouteTitle } from "../../utils/navigation";
import "./admin.scss";

const Admin = () => {
	const navigate = useNavigate();
	const [time, setTime] = useState(Date().substring(16, 24));
	const [day, setDay] = useState(
		`${Date().substring(0, 3)}, ${Date().substring(
			4,
			7
		)} ${Date().substring(8, 10)}`
	);
	setInterval(() => {
		setTime(Date().substring(16, 24));
	}, 1000);
	setInterval(() => {
		setDay(
			`${Date().substring(0, 3)}, ${Date().substring(
				4,
				7
			)} ${Date().substring(8, 10)}`
		);
	}, 86400000);
	const location = useLocation();
	const [openNav, setOpenNav] = useState(false);
	useEffect(() => {
		setOpenNav(false);
	}, [location.pathname]);
	useEffect(() => {
		document.addEventListener("keydown", (e) => {
			if (e.key === "Escape") setOpenNav(false);
		});
		return () => {
			document.removeEventListener("keydown", (e) => {
				if (e.key === "Escape") setOpenNav(false);
			});
		};
	}, []);
	return (
		<main
			className="admin"
			style={{
				backgroundImage: `url(${adminBg})`,
			}}
		>
			<section className="header admin-header">
				<div
					className="header-current"
					onClick={() => setOpenNav((p) => !p)}
				>
					<span className="header-current-route">
						{getRouteTitle(location.pathname)}
					</span>
					<MaterialIcons>unfold_more</MaterialIcons>
				</div>
				<div
					className={`header-routes-list ${
						openNav && "header-routes-list-active"
					}`}
				>
					{navLinks.map(({ icon, route, text }, index) => (
						<Link key={index} to={route} className="header-route">
							{icon}
							{text}
						</Link>
					))}
				</div>
			</section>
			<section className="admin-body">
				<div
					className="admin-left"
					style={{
						backgroundImage: `url(${statsBg})`,
					}}
				>
					<div className="admin-left-card">
						<div className="admin-left-card-header">
							<h1>Statistics</h1>
						</div>
						<div className="admin-left-card-body">
							<div className="admin-left-card-body-item">
								<span>Members: </span>
								<span>65</span>
							</div>
							<div className="admin-left-card-body-item">
								<span>No. of Events: </span>
								<span>5</span>
							</div>
						</div>
					</div>
				</div>
				<div
					className="admin-right"
					style={{
						backgroundImage: `url(${trip})`,
					}}
				>
					<div className="admin-right-clock">
						<MaterialIcons>
							{+Date().slice(16, 18) > 7 &&
							+Date().slice(16, 18) < 20
								? "clear_day"
								: "bedtime"}
						</MaterialIcons>
						<div className="admin-right-clock-content">
							<span className="admin-right-clock__day">
								{day}
							</span>
							<span className="admin-right-clock__time">
								{time}
							</span>
						</div>
					</div>
				</div>
				<div
					className="admin-controls"
					style={{
						backgroundImage: `url(${actions})`,
					}}
				>
					<h1>Actions</h1>
					<div className="admin-controls-btns">
						<button onClick={() => navigate(`/admin/members`)}>
							<MaterialIcons>people</MaterialIcons>
							<span>Manage Members</span>
						</button>
						<button onClick={() => navigate(`/admin/applications`)}>
							<MaterialIcons>mark_email_unread</MaterialIcons>
							<span>Review Applications</span>
						</button>
						<button onClick={() => navigate(`/logout`)}>
							<MaterialIcons>logout</MaterialIcons>
							<span>Logout</span>
						</button>
					</div>
				</div>
			</section>
		</main>
	);
};

export default Admin;
